import React from "react";

import { Formik, Form } from "formik";
import { Delete } from "icons";
import * as yup from "yup";

import { Button, Typography } from "clearsense-ui/components";
import { Input, Textarea, DatePicker } from "clearsense-ui/components/formik";
import ContentBox from "components/Common/ContentBox";
import {
  CREATE_SOURCE_VALUES_INITIAL_VALUES,
  CREATE_SOURCE_VALUES_VALIDATION_SCHEMA,
} from "components/DataManagement/DataSources/constants/createReferenceSourceValues";

const AddNewValue = ({ setVisible, setValues, position, values }) => {
  const addValueToList = payload => {
    if (!isNaN(position)) {
      const editedValues = values;
      editedValues?.splice(position, 1, payload);
      setValues(editedValues);
    } else {
      setValues(prev => [...prev, payload]);
    }
  };

  const submitForm = async values => {
    try {
      const payload = {
        name: values?.valueName,
        description: values?.valueDescription,
        start_date: values?.startDate,
        end_date: values?.endDate,
      };
      addValueToList(payload);
      setVisible(false);
    } catch (error) {
      logger.log(error);
    }
  };

  const handleDelete = () => {
    setValues(() => values.filter((value, index) => index !== position));
    setVisible(false);
  };

  return (
    <ContentBox className="w-full flex flex-col gap-2 mb-2">
      <Formik
        initialValues={
          !isNaN(position)
            ? {
                valueName: values?.[position]?.name,
                valueDescription: values?.[position]?.description,
                startDate: values?.[position]?.start_date,
                endDate: values?.[position]?.end_date,
              }
            : CREATE_SOURCE_VALUES_INITIAL_VALUES
        }
        validationSchema={yup.object(CREATE_SOURCE_VALUES_VALIDATION_SCHEMA)}
        enableReinitialize
        onSubmit={submitForm}
      >
        <Form noValidate className="flex flex-col gap-4">
          <Typography className="text-gray-500">Add a New Value</Typography>
          <Input
            name="valueName"
            label="Value Name"
            placeholder="Enter a Value Name"
            required
          />
          <Textarea
            name="valueDescription"
            label="Value Description"
            rows={3}
            placeholder="Enter a Description for the value"
          />
          <DatePicker
            name="startDate"
            dateFormat="YYYY-MM-DD"
            label="Effective Start Date"
          />
          <DatePicker
            name="endDate"
            dateFormat="YYYY-MM-DD"
            label="Effective End Date"
          />
          <div className="flex items-center">
            <Button label="Save Value" type="submit" />
            <Button
              label="Cancel"
              style="text"
              onClick={() => setVisible(false)}
            />
            {!isNaN(position) && (
              <Button
                icon={Delete}
                className="text-red-600"
                style="secondary"
                onClick={handleDelete}
              />
            )}
          </div>
        </Form>
      </Formik>
    </ContentBox>
  );
};

export default AddNewValue;
